import { Box, Popover, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useAuth } from '../Firebase/AuthProvider';
import { useFirestore } from '../Firebase/FirestoreProvider';
import { fullCenter, pastelBlue, pastelRed } from '../Pages/Main/constants';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { getInputText } from './EditableTypography';
import LazyImage from './LazyImage';

export default function EditableImage({ fireKey, noPropagation = false, defaultVisible = false, comment, path, lazy = true, src, ...props }) {
    const [loaded, setLoaded] = useState(false);
    const [valid, setValid] = React.useState(true);
    const { getData, changeData } = useFirestore();
    const { isAdmin } = useAuth();
    const [anchorEl, setAnchorEl] = useState(null);
    const value = getData(fireKey, path);
    const disablePropagation = Boolean(isAdmin && noPropagation);

    const handleClick = (e) => {
        if (disablePropagation) {
            e.preventDefault();
            e.stopPropagation();
        }
        setAnchorEl(e.currentTarget);
    };

    const handleClose = (e) => {
        if (disablePropagation) {
            e.preventDefault();
            e.stopPropagation();
        }
        setAnchorEl(null);
    };

    const handleChange = (e) => {
        if (disablePropagation) {
            e.preventDefault();
            e.stopPropagation();
        }
        const value = e.target.value;
        changeData(fireKey, value, path);
    }

    const isAbsolute = props?.sx?.position === "absolute";

    if (!valid && !isAdmin) return null;

    return (
        <>
            <div style={{ position: isAbsolute ? 'static' : 'relative' }}>
                {lazy ? <LazyImage
                    defaultVisible={defaultVisible}
                    src={value || src}
                    onError={(e) => { setValid(false); console.log(e) }}
                    onLoad={() => setLoaded(true)}
                    style={{ opacity: loaded ? 1 : 0 }}
                    {...props} /> :
                    <Box component={'img'}
                        src={value || src}
                        onError={(e) => { setValid(false); console.log(e) }}
                        onLoad={() => setLoaded(true)}
                        style={{ opacity: 1 }} {...props} />}


                {isAdmin && <Box component='span'
                    sx={{
                        width: '34px', height: '34px', maxWidth: '34px', maxHeight: '34px', minWidth: '34px', borderRadius: '50%',
                        bgcolor: pastelRed,
                        scale: 1,
                        transition: 'scale 0.2s ease-in-out',
                        "&:hover": { scale: 1.05 },
                        zIndex: 18, position: 'absolute', cursor: 'pointer', ...fullCenter,
                        bottom: 10, left: 10
                    }}
                    onClick={(e) => {
                        if (disablePropagation) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        handleClick(e);
                    }} >

                    <EditRoundedIcon sx={{ color: 'white' }} />
                </Box>}
            </div>
            {isAdmin &&
                <>
                    <Popover
                        disableScrollLock
                        id={fireKey}
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <Box sx={{ minWidth: '300px', width: '600px', maxWidth: '800px', p: '10px' }} onClick={(e) => {
                            if (disablePropagation) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        }}>
                            <Typography sx={{ pb: '10px', fontWeight: 'bold', pointerEvents: 'none' }}>IMAGE id: {fireKey || path}</Typography>
                            {Boolean(comment) && <Typography sx={{ pb: '10px', pointerEvents: 'none' }}>{comment}</Typography>}
                            <TextField
                                sx={{ width: '100%' }}
                                multiline
                                value={getInputText(value)}
                                onChange={handleChange}
                            />
                        </Box>
                    </Popover>
                </>}
        </>
    )
}
